import { render } from "./BookingUnderApprovalCard.vue?vue&type=template&id=1cc65ba2&scoped=true"
import script from "./BookingUnderApprovalCard.vue?vue&type=script&lang=js"
export * from "./BookingUnderApprovalCard.vue?vue&type=script&lang=js"

import "./BookingUnderApprovalCard.vue?vue&type=style&index=0&id=1cc65ba2&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc65ba2"]])

export default __exports__